import GitHub from '@/components/Icons/GitHub'
import MarkDownIcon from '@/components/Icons/MarkDownIcon'
import ChatGPTIcon from '@/components/Icons/ChatGPTIcon'
import ClaudeIcon from '@/components/Icons/ClaudeIcon'
import VsCodeIcon from '@/components/Icons/VsCodeIcon'
import { Copy, Printer } from 'lucide-react'

export const EXPORT_MENU_ITEMS = [
  {
    group: 'primary',
    items: [
      {
        icon: Copy,
        label: 'Copy page',
        description: 'Copy page as Markdown for LLMs',
        action: 'copy',
      },
      {
        icon: MarkDownIcon,
        label: 'View as Markdown',
        description: 'View this page as plain text',
        action: 'markdown',
        external: true,
      },
    ],
  },
  {
    group: 'ai',
    items: [
      {
        icon: ChatGPTIcon,
        label: 'Open in ChatGPT',
        description: 'Ask ChatGPT about this page',
        action: 'chatgpt',
        external: true,
      },
      {
        icon: ClaudeIcon,
        label: 'Open in Claude',
        description: 'Ask Claude about this page',
        action: 'claude',
        external: true,
      },
    ],
  },
  {
    group: 'dev',
    items: [
      {
        icon: VsCodeIcon,
        label: 'Connect to VSCode',
        description: 'Use this MCP in VSCode',
        action: 'vscode',
        external: true,
      },
    ],
  },
  {
    group: 'misc',
    items: [
      {
        icon: Printer,
        label: 'Export as PDF',
        description: 'Print or save as PDF',
        action: 'pdf',
      },
      {
        icon: GitHub,
        label: 'Edit on GitHub',
        description: 'Edit this page on GitHub',
        action: 'edit',
        external: true,
      },
    ],
  },
]
